import * as React from 'react'
import { ChakraProvider } from '@chakra-ui/react'
import "./src/theme/global.css"
import "@fontsource/roboto";
import "@fontsource/roboto-condensed";
import '@fontsource-variable/sofia-sans-extra-condensed';
import "@fontsource/roboto-mono";
import "@fontsource/bitter";
import { customTheme } from './src/theme'


export const wrapRootElement = ({ element }) => (
  <ChakraProvider theme={customTheme}>
    {element}
  </ChakraProvider>
)